import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../../service.service';
import { ActivatedRoute } from '@angular/router';
import { GlobalConstants } from '../../global-config'
import { MetaServiceService } from '../../meta-service.service';


@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrls: ['./blog-details.component.scss']
})
export class BlogDetailsComponent implements OnInit {
  public server = GlobalConstants.apiURL;

  blogData:any;
  singleBlogData:any;
  dateFormattedString:any;
  constructor(
    public service: ServiceService,
    private activatedRoute :ActivatedRoute,
    private metaService: MetaServiceService
    ) { }

  ngOnInit(): any {
    // for create canonical link 
    this.metaService.createCanonicalURL();  
    // to get particular blog id
    let bid = this.activatedRoute.snapshot.params.id;
    // console.log("url se id aa rahi hai", +bid);
     
    //to get data of particular blog by id
    this.getSingleBlog(bid);
    
    
    // to get all blog data
    this.getBlogAll();

  } 

  getBlogAll() {
    this.service.getBlog().subscribe((data: any[]) => {
     this.blogData=data;
     console.log(this.blogData);
     
   });
   (error) => {
     console.log("no data found");
   };
 }

 getSingleBlog(bid){
  this.service.getSingleBlog(bid).subscribe((data: any[]) => {
    this.singleBlogData=data;
    console.log(this.singleBlogData);
    var date=new Date(this.singleBlogData.createdAt);
    this.dateFormattedString=date.getDate()+"/"+date.getMonth()+"/"+date.getFullYear();    
  });
  (error) => {
    console.log("no data found");
  };

 }


}
